<div fxLayout="row wrap">
    <div  fxFlex="100" fxFlex.xl="25" fxFlex.lg="25" fxFlex.md="50" fxFlex.sm="50" class="p-2" *ngIf="userRole=='proprietaire'">        
        <mat-card class="gradient-green tile p-2"> 
            <mat-icon>monetization_on</mat-icon> 
            <h3>...</h3>
            <h3>{{currency}} {{(datas$ | async)?.profit}}</h3>         
            <p>Mon profit</p>            
        </mat-card>  
    </div>
    <div fxFlex="100" fxFlex.xl="25" fxFlex.lg="25" fxFlex.md="50" fxFlex.sm="50" class="p-2" *ngIf="userRole=='proprietaire'">        
        <mat-card class="gradient-red tile p-2"> 
            <mat-icon>thumb_up_alt</mat-icon>
            <h3>...</h3> 
            <h3>{{(datas$ | async)?.numberOfCar}}</h3>         
            <p>Total Véhicules</p>            
        </mat-card>
    </div>
    <div fxFlex="100" fxFlex.xl="25" fxFlex.lg="25" fxFlex.md="50" fxFlex.sm="50" class="p-2">
        <mat-card class="gradient-orange tile p-2">
            <mat-icon>group</mat-icon> 
            <h3><span *ngIf="userRole=='proprietaire'">L :</span> {{(datas$ | async)?.numberOfRenting?.logder}}</h3>
            <h3 *ngIf="userRole=='proprietaire'">P : {{(datas$ | async)?.numberOfRenting?.owner}}</h3>         
            <p>Total Locations</p> 
        </mat-card>
    </div>
    <div fxFlex="100" fxFlex.xl="25" fxFlex.lg="25" fxFlex.md="50" fxFlex.sm="50" class="p-2">
        <mat-card class="gradient-pink tile p-2">
            <mat-icon>shopping_cart</mat-icon> 
            <h3><span *ngIf="userRole=='proprietaire'">L :</span> {{(datas$ | async)?.rentingInProgress?.logder}}</h3>
            <h3 *ngIf="userRole=='proprietaire'">P : {{(datas$ | async)?.rentingInProgress?.owner}}</h3> 
            <p>Location Encours</p> 
        </mat-card>
    </div>    
    <div fxFlex="100" fxFlex.xl="25" fxFlex.lg="25" fxFlex.md="50" fxFlex.sm="50" class="p-2">
        <mat-card class="gradient-gray tile p-2">
            <mat-icon>pie_chart</mat-icon> 
            <h3><span *ngIf="userRole=='proprietaire'">L :</span> {{(datas$ | async)?.numberOfNewRenting?.logder}}</h3>
            <h3 *ngIf="userRole=='proprietaire'">P : {{(datas$ | async)?.numberOfNewRenting?.owner}}</h3>     
            <p>Location En Attente De Validation</p> 
        </mat-card>
    </div> 
    <div fxFlex="100" fxFlex.xl="25" fxFlex.lg="25" fxFlex.md="50" fxFlex.sm="50" class="p-2">
        <mat-card class="gradient-brown tile p-2">
            <mat-icon>save_alt</mat-icon> 
            <h3><span *ngIf="userRole=='proprietaire'">L :</span> {{(datas$ | async)?.numberOfRentingAwaintingPayment?.logder}}</h3>
            <h3 *ngIf="userRole=='proprietaire'">P : {{(datas$ | async)?.numberOfRentingAwaintingPayment?.owner}}</h3>     
            <p>Location En Attente De Paiement</p> 
        </mat-card>
    </div> 
    <div  fxFlex="100" fxFlex.xl="25" fxFlex.lg="25" fxFlex.md="50" fxFlex.sm="50" class="p-2">        
        <mat-card class="gradient-green tile p-2"> 
            <mat-icon>monetization_on</mat-icon> 
            <h3>...</h3>
            <h3>{{currency}} {{(datas$ | async)?.asset}}</h3>         
            <p>Avoirs</p>            
        </mat-card>  
    </div>
</div>
<!--
    fxFlex="100" fxFlex.gt-sm="25" fxFlex.sm="50" class="p-2"
-->
